import styled from "styled-components";
import Box from "../../Styled/Box";
import { TOUR_WIDTH } from "./tour-helpers";
// TODO: make relative to app z-index
export const TourExplanationBoxZIndex = 10000;
export const TourExplanationBox = styled(Box).withConfig({
  displayName: "TourExplanationBox",
  componentId: "sc-1ggu43p-0"
})(["position:absolute;width:", "px;z-index:", ";background:white;min-height:136px;border-radius:4px;box-shadow:0 6px 6px 0 rgba(0,0,0,0.12),0 10px 20px 0 rgba(0,0,0,0.05);h1,h2,h3,h4,h5,h6{margin:0;padding:0;}h1,h2,h3{margin-bottom:", "px;font-size:16px;font-weight:bold;}h4,h5,h6{font-size:15px;}p{margin:0;margin-bottom:", "px;}p:last-child{margin-bottom:0;}"], p => p.longer ? "".concat(TOUR_WIDTH + 55) : "".concat(TOUR_WIDTH), TourExplanationBoxZIndex, p => p.theme.spacing * 3, p => p.theme.spacing);
export default TourExplanationBox;